import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@delon/theme';

/** wa.me links to the QNE WhatsApp AI Support numbers, keyed by company country. */
export const WHATSAPP_SUPPORT_LINKS: Readonly<Record<string, string>> = {
  MY: 'https://wa.me/60176263368'
};

/** Used for every country that has no entry in {@link WHATSAPP_SUPPORT_LINKS}. */
export const DEFAULT_WHATSAPP_SUPPORT_LINK = 'https://wa.me/60122094134';

/** Countries with no WhatsApp AI Support channel; they keep Live Chat (Freshchat). */
export const COUNTRIES_WITHOUT_WHATSAPP_SUPPORT: readonly string[] = ['PH'];

/**
 * Resolves the WhatsApp AI Support link for the signed-in company's country.
 * Shared by every widget that offers the channel (chatbot menu, trial reminder)
 * so the numbers and the country rule live in one place.
 */
@Injectable({ providedIn: 'root' })
export class WhatsAppSupportService {
  private readonly settings = inject(SettingsService);

  private get country(): string {
    return this.settings.user?.['company']?.country ?? '';
  }

  /** False for countries that still use Live Chat instead of WhatsApp AI Support. */
  get isAvailable(): boolean {
    return !COUNTRIES_WITHOUT_WHATSAPP_SUPPORT.includes(this.country);
  }

  get link(): string {
    return WHATSAPP_SUPPORT_LINKS[this.country] ?? DEFAULT_WHATSAPP_SUPPORT_LINK;
  }

  open(): void {
    window.open(this.link, '_blank', 'noopener');
  }
}
